var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFt3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DB0035",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41797 15.4742L22.5608 9.49707",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 8.57129L22.5607 9.497L21.6464 11.9541",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1423 23.4284H20.2852V15.4284C20.2852 15.2768 20.3454 15.1315 20.4525 15.0243C20.5597 14.9171 20.705 14.8569 20.8566 14.8569H22.5709C22.7224 14.8569 22.8678 14.9171 22.975 15.0243C23.0821 15.1315 23.1423 15.2768 23.1423 15.4284V23.4284Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4294 23.4284H14.5723V17.1427C14.5723 16.9912 14.6325 16.8458 14.7396 16.7387C14.8468 16.6315 14.9921 16.5713 15.1437 16.5713H16.858C17.0095 16.5713 17.1549 16.6315 17.262 16.7387C17.3692 16.8458 17.4294 16.9912 17.4294 17.1427V23.4284Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7146 23.4285H8.85742V18.8571C8.85742 18.7055 8.91763 18.5602 9.02479 18.453C9.13195 18.3459 9.2773 18.2856 9.42885 18.2856H11.1431C11.2947 18.2856 11.44 18.3459 11.5472 18.453C11.6544 18.5602 11.7146 18.7055 11.7146 18.8571V23.4285Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1423 23.4284H20.2852V15.4284C20.2852 15.2768 20.3454 15.1315 20.4525 15.0243C20.5597 14.9171 20.705 14.8569 20.8566 14.8569H22.5709C22.7224 14.8569 22.8678 14.9171 22.975 15.0243C23.0821 15.1315 23.1423 15.2768 23.1423 15.4284V23.4284Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4294 23.4284H14.5723V17.1427C14.5723 16.9912 14.6325 16.8458 14.7396 16.7387C14.8468 16.6315 14.9921 16.5713 15.1437 16.5713H16.858C17.0095 16.5713 17.1549 16.6315 17.262 16.7387C17.3692 16.8458 17.4294 16.9912 17.4294 17.1427V23.4284Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7146 23.4285H8.85742V18.8571C8.85742 18.7055 8.91763 18.5602 9.02479 18.453C9.13195 18.3459 9.2773 18.2856 9.42885 18.2856H11.1431C11.2947 18.2856 11.44 18.3459 11.5472 18.453C11.6544 18.5602 11.7146 18.7055 11.7146 18.8571V23.4285Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt3);
export default __webpack_public_path__ + "static/media/ft_3.eea94876728c6b687fcceaf4852940fa.svg";
export { ForwardRef as ReactComponent };